import { Tabs } from '@chakra-ui/react';
import { memo } from 'react';

import {
  PlanningBacklogHeader,
  PlanningBoardColumn,
  PlanningBacklogCoachingToolsTab,
  PlanningBacklogChallengesTab,
} from 'features/planning';

import { BoardColumnWrapper } from 'shared/components/Board';

export const PlanningBacklog = memo(() => (
  <PlanningBoardColumn>
    <BoardColumnWrapper fraction={2}>
      <Tabs.Root defaultValue={0} colorPalette="blue" height="100%" lazyMount>
        <PlanningBacklogHeader />
        <Tabs.ContentGroup height={`calc(100% - ${columnHeaderMinHeight})`}>
          <PlanningBacklogChallengesTab />
          <PlanningBacklogCoachingToolsTab />
        </Tabs.ContentGroup>
      </Tabs.Root>
    </BoardColumnWrapper>
  </PlanningBoardColumn>
));

const columnHeaderMinHeight = '3rem';
